// GENERATED by build/build_qb_data.py from content/quote-tool/systems.yaml
// DO NOT EDIT BY HAND - edit the YAML and rebuild (CLAUDE.md conventions).
window.QB_DATA = {
 "categories": [
  {
   "name": "Microcement",
   "icon": "🎨",
   "products": [
    "decorkrete",
    "decork-facade",
    "decork-mediterraneo"
   ]
  },
  {
   "name": "Waterproofing",
   "icon": "💧",
   "products": [
    "watstop",
    "acriflex-fybro",
    "acriflex-x-pro",
    "acriflex-ph4",
    "thermikoat-cool-roof",
    "ultragum"
   ]
  },
  {
   "name": "Primers",
   "icon": "🔧",
   "products": [
    "grip-primer",
    "aquabond",
    "sbs-bond",
    "colour-primer",
    "acriflex-primer",
    "d20"
   ]
  },
  {
   "name": "Thermal Plasters",
   "icon": "🌡️",
   "products": [
    "diathonite-thermactive-037",
    "diathonite-evolution",
    "diathonite-deumix"
   ]
  },
  {
   "name": "Acoustic Plasters",
   "icon": "🔇",
   "products": [
    "diathonite-acoustix-plus"
   ]
  },
  {
   "name": "Screeds & Structural",
   "icon": "🏗️",
   "products": [
    "diathonite-screed",
    "diathonite-thermostep-047",
    "diathonite-sismactive"
   ]
  },
  {
   "name": "Sealers & Coatings",
   "icon": "🛡️",
   "products": [
    "aquafloor-eco",
    "pool-protector",
    "bkk-eco",
    "floorgum-tyre-mono"
   ]
  },
  {
   "name": "Finishes & Smoothers",
   "icon": "✨",
   "products": [
    "limepaint",
    "plasterpaint-coloured",
    "argatherm",
    "argatherm-ultrafine",
    "argacem-coloured",
    "argatherm-acoustix",
    "ardex-x-5"
   ]
  },
  {
   "name": "Reinforcement",
   "icon": "🔩",
   "products": [
    "polites-80",
    "polites-140",
    "polites-tnt",
    "safety-joint-roll-tape",
    "polites-ar-250",
    "polites-ar-330"
   ]
  },
  {
   "name": "Accessories",
   "icon": "🧰",
   "products": [
    "diafon",
    "diaseal-strong",
    "ardex-x-5",
    "sismabond",
    "safety-joint-roll-tape"
   ]
  }
 ],
 "collections": [
  {
   "name": "Decorative Coatings & Natural Paints",
   "handle": "decorative-coatings-and-natural-paints"
  },
  {
   "name": "Cork Based Plasters & Screeds",
   "handle": "cork-based-plasters-screeds"
  },
  {
   "name": "Finishing Plaster & Stucco",
   "handle": "smoothing-plasters"
  },
  {
   "name": "Cork Based Thermal Paints",
   "handle": "cork-based-thermal-paints"
  },
  {
   "name": "Clear Coats & Sealants",
   "handle": "clear-coats-sealants"
  },
  {
   "name": "Waterproofing",
   "handle": "water-proofing"
  },
  {
   "name": "Primers",
   "handle": "primers"
  },
  {
   "name": "Tools & Accessories",
   "handle": "tools-accessories"
  },
  {
   "name": "Samples",
   "handle": "samples"
  }
 ],
 "rates": {
  "grip-primer": {
   "yieldKgM2": 0.2,
   "coats": 1
  },
  "aquabond": {
   "yieldKgM2": 0.25,
   "coats": 1
  },
  "sbs-bond": {
   "yieldKgM2": 0.15,
   "coats": 1
  },
  "colour-primer": {
   "yieldKgM2": 0.2,
   "coats": 1
  },
  "acriflex-primer": {
   "yieldKgM2": 0.15,
   "coats": 1
  },
  "c-w-c-stop-conden": {
   "yieldKgM2": 0.6,
   "coats": 2,
   "_note": "Canon yield 0.60 kg/m2 (cwc-stop-condense.yaml, field-verified from kit-size math; the TDS prints 0.5 L/m2 and this product is the exception to the 1:1 L-to-kg rule). Live handle c-w-c-stop-conden."
  },
  "watstop": {
   "yieldKgM2": 1.0,
   "coats": 2,
   "hasMode": true,
   "modes": {
    "waterproofing-1": {
     "coats": 2,
     "yieldKgM2": 0.5,
     "label": "Vapour barrier 1 kg/m² (2 coats)"
    },
    "waterproofing-2": {
     "coats": 2,
     "label": "Waterproofing 2 kg/m² (2 coats)"
    }
   }
  },
  "ultragum": {
   "yieldKgM2": 1.0,
   "coats": 2
  },
  "decorkrete": {
   "yieldKgM2": 0.6,
   "coats": 2
  },
  "limepaint": {
   "yieldKgM2": 0.175,
   "coats": 2
  },
  "plasterpaint-coloured": {
   "yieldKgM2": 0.25,
   "coats": 2
  },
  "argatherm": {
   "yieldKgM2": 1.8,
   "coats": 2
  },
  "argatherm-ultrafine": {
   "yieldKgM2": 1.0,
   "coats": 2,
   "pack_kg": 25,
   "_note": "CANON BACKFILLED 2026-09-08 from the TDS J. Nelson supplied (the file the product YAML recorded as missing). Yield is 1.0 kg/m2 PER MM, max 1 mm per coat, 2.0 mm max total, so a full build is two coats at 1.0 = 2.0 kg/m2. The store agrees: the 25 kg bag is listed as 25 kg (12.5 m2) = 2.0 kg/m2. The old seed said coats 1, so every quote bought HALF the product the job needed."
  },
  "argacem-coloured": {
   "yieldKgM2": 1.75,
   "coats": 2
  },
  "argatherm-acoustix": {
   "yieldKgM2": 1.05,
   "coats": 2
  },
  "decork-facade": {
   "yieldKgM2": 0.5,
   "coats": 2
  },
  "decork-mediterraneo": {
   "yieldKgM2": 0.25,
   "coats": 2
  },
  "aquafloor-eco": {
   "yieldKgM2": 0.0667,
   "coats": 3
  },
  "pool-protector": {
   "yieldKgM2": 0.12,
   "coats": 3
  },
  "d20": {
   "yieldKgM2": 0.15,
   "coats": 1
  },
  "floorgum-tyre-mono": {
   "yieldKgM2": 0.5,
   "coats": 2
  },
  "bkk-eco": {
   "yieldKgM2": 0.4,
   "coats": 1
  },
  "thermikoat-cool-roof": {
   "yieldKgM2": 1.0,
   "coats": 2
  },
  "acriflex-fybro": {
   "yieldKgM2": 1.0,
   "coats": 2
  },
  "acriflex-x-pro": {
   "yieldKgM2": 1.0,
   "coats": 2
  },
  "acriflex-ph4": {
   "yieldKgM2": 1.25,
   "coats": 2
  },
  "diathonite-thermactive-037": {
   "yieldPer10mm": 2.6,
   "isDiathonite": true,
   "default_thickness_mm": 40,
   "min_thickness_mm": 15
  },
  "diathonite-evolution": {
   "yieldPer10mm": 3.7,
   "isDiathonite": true,
   "min_thickness_mm": 15
  },
  "diathonite-deumix": {
   "yieldPer10mm": 4.4,
   "isDiathonite": true,
   "default_thickness_mm": 30,
   "min_thickness_mm": 15
  },
  "diathonite-acoustix-plus": {
   "yieldPer10mm": 4.0,
   "isDiathonite": true,
   "min_thickness_mm": 15
  },
  "diathonite-sismactive": {
   "yieldPer10mm": 6.0,
   "isDiathonite": true,
   "min_thickness_mm": 15
  },
  "diathonite-screed": {
   "yieldPer10mm": 6.0,
   "isDiathonite": true,
   "default_thickness_mm": 50,
   "min_thickness_mm": 40
  },
  "diathonite-thermostep-047": {
   "yieldPer10mm": 3.9,
   "isDiathonite": true,
   "min_thickness_mm": 30
  },
  "safety-joint-roll-tape": {
   "isLinear": true,
   "coveragePerUnitM": 20,
   "seamFactorMetric": 0.82,
   "unitLabel": "roll"
  },
  "ardex-sk-mesh-25": {
   "isLinear": true,
   "coveragePerUnitM": 25,
   "seamFactorMetric": 0.82,
   "unitLabel": "roll"
  },
  "diaseal-strong": {
   "isLinear": true,
   "coveragePerUnitM": 12,
   "seamFactorMetric": 0.82,
   "unitLabel": "sausage"
  },
  "polites-80": {
   "isRoll": true,
   "rollCoverageM2": 50,
   "overlapFactor": 1.1
  },
  "polites-140": {
   "isRoll": true,
   "rollCoverageM2": 50,
   "overlapFactor": 1.1
  },
  "polites-tnt": {
   "isRoll": true,
   "rollCoverageM2": 20,
   "overlapFactor": 1.03
  },
  "ardex-x-5": {
   "yieldKgM2": 1.1,
   "coats": 1,
   "pack_kg": 18,
   "_note": "REMODELED 2026-09-06: was isLinear 330 m/bag (that number is the WATER RATIO, ml/kg); canon = area skim ~1.1 kg/m2 at 1.5 mm nominal (ardex-x5.yaml skim band, J. Nelson 2026-08-29); full-surface float on plywood per field ruling."
  }
 },
 "guided": {
  "_contract": "Consumed by qb-customer.js (Phase 2 Step 6). GUIDED-TAB rules fire when the picked system key is in `systems` (omit = every system) AND the handleized substrate label token-matches an entry in `substrates` (same token-subset match as QBEngine.resolveSubstrateKey; omit = every substrate); rules with `always: true` fire on system pick alone. A rule with `route_has: <productId>` fires only when the resolved route contains that product (e.g. the WATstop overcoat card is hidden on a Grip-Primer route like Kerdi Board). Substrate match is one-directional: the rule's tokens must all be in the picked label, so a general label (Wood) never matches a specific rule (wood-lap-siding). QUICK-TAB rules fire on quote contents: every handle in `all_of` present (absent = pass), at least one of `any_of` present (when given), and NONE of `missing` present (when given). Severity: stop blocks quoting, warn shows amber and allows, info is an inline note. No stop rules yet - the substrate picker only offers routed substrates, so nothing pickable earns a stop; the tier is reserved. Verified against canon 2026-09-06 (workflow wf_b7fa5fb6-fc1: canon refuter + coverage critic + voice check, all verdicts folded).",
  "default_unit": "ft2",
  "thickness_options": [
   10,
   20,
   30,
   40,
   50,
   60
  ],
  "waste_options": [
   {
    "value": 1.05,
    "label": "5%: flat, open floors"
   },
   {
    "value": 1.1,
    "label": "10%: most jobs",
    "default": true
   },
   {
    "value": 1.15,
    "label": "15%: cuts, corners, small rooms"
   },
   {
    "value": 1.2,
    "label": "20%: first job with the system"
   },
   {
    "value": 1.25,
    "label": "25%: stairs, niches, curved or detailed work"
   }
  ],
  "families": [
   {
    "key": "microcement",
    "name": "Microcement",
    "icon": "🪨",
    "blurb": "Decorkrete systems for floors, showers, counters, walls, fireplaces, furniture and patios."
   },
   {
    "key": "cork",
    "name": "Cork",
    "icon": "🌳",
    "blurb": "Decork Facade and Mediterraneo cork coatings for exterior and interior walls."
   }
  ],
  "step_roles": {
   "watstop": {
    "label": "Waterproofing",
    "role": "Epoxy-cement membrane. Two coats for the vapour barrier, two heavier coats for full waterproofing."
   },
   "decorkrete": {
    "label": "Microcement",
    "role": "Two coats of the finish, both toned."
   },
   "d20": {
    "label": "Fixative",
    "role": "Water-based primer that binds the dust before the sealer."
   },
   "aquafloor-eco": {
    "label": "Sealer",
    "role": "Clear two-part polyurethane, three thin coats. Leaves the texture showing."
   },
   "grip-primer": {
    "label": "Primer",
    "role": "One coat of grip on smooth, non-absorbent substrates."
   },
   "ardex-x-5": {
    "label": "Grout Fill",
    "role": "Cement fill for grout lines, seams and repairs before the membrane goes on. On plywood, a thin full-surface skim."
   },
   "decork-facade": {
    "label": "Cork coating",
    "role": "Coloured cork finish for exterior walls. Water-repellent, breathable, thermal."
   },
   "decork-mediterraneo": {
    "label": "Cork coating",
    "role": "Coloured fine-grain cork finish for interior walls. Breathable."
   }
  },
  "color_finish": [
   "decorkrete",
   "decork-facade",
   "decork-mediterraneo"
  ],
  "prep": [
   {
    "product": "safety-joint-roll-tape",
    "suggestion": "linear",
    "label": "Safety Joint Roll",
    "role": "Perimeter and transition band, embedded in WATstop. Measure your linear feet.",
    "applies": {
     "showers": [
      "moisture-resistant-drywall",
      "concrete-dry",
      "concrete-damp",
      "tile",
      "cement-board"
     ],
     "floors": [
      "concrete-dry",
      "concrete-damp"
     ]
    }
   },
   {
    "product": "ardex-x-5",
    "suggestion": "area",
    "label": "Ardex X5",
    "role": "Grout-line fill on tile, full-surface skim on plywood. Reduce for grout-only work.",
    "applies": {
     "showers": [
      "moisture-resistant-drywall"
     ],
     "floors": [
      "plywood",
      "tile"
     ],
     "countertops": [
      "*"
     ],
     "walls": [
      "tile",
      "cement-board",
      "plywood"
     ],
     "fireplaces": [
      "tile",
      "cement-board",
      "plywood"
     ],
     "furniture": [
      "wood",
      "laminate"
     ]
    }
   },
   {
    "product": "ardex-sk-mesh-25",
    "suggestion": "linear",
    "label": "Ardex SK Mesh",
    "role": "Seam tape for panel joints, embedded in Ardex X5. Measure your seam feet.",
    "applies": {
     "showers": [
      "cement-board",
      "moisture-resistant-drywall"
     ],
     "walls": [
      "cement-board",
      "plywood"
     ],
     "fireplaces": [
      "cement-board",
      "plywood"
     ],
     "countertops": [
      "cement-board",
      "plywood"
     ],
     "floors": [
      "plywood"
     ]
    }
   },
   {
    "product": "diaseal-strong",
    "suggestion": "linear",
    "label": "Diaseal Strong",
    "role": "Flexible fill for movement and control joints. Measure your linear feet.",
    "applies": {
     "floors": [
      "*"
     ],
     "patios": [
      "*"
     ]
    }
   }
  ],
  "guardrails": [
   {
    "id": "wet-tile-prep",
    "tab": "guided",
    "severity": "warn",
    "systems": [
     "showers",
     "patios"
    ],
    "substrates": [
     "tile"
    ],
    "attach_to": "ardex-x-5",
    "message": "Degrease tile, lightly sand and rinse. Deep grout lines fill with Ardex X5 first; WATstop then rolls over the whole field at 2 kg/m² for full waterproofing or 1 kg/m² for vapour barrier.",
    "_source": "technical-facts.md Joint treatments (X5 fills, WATstop seals over - J. Nelson correction 2026-09-06) + install-steps PREP_WET_AREAS/PREP_GENERAL (tile prep). Patios included - its default route is the WATstop wet build."
   },
   {
    "id": "dry-tile-prep",
    "tab": "guided",
    "severity": "warn",
    "systems": [
     "floors",
     "walls",
     "countertops",
     "fireplaces"
    ],
    "substrates": [
     "tile"
    ],
    "attach_to": "ardex-x-5",
    "message": "Use Ardex X5 in deep grout lines (over 3 mm) first, then Grip Primer over the field.",
    "_source": "technical-facts.md Joint treatments (J. Nelson 2026-08-29 scope ruling) + install-steps PREP_FLOORS/PREP_WALLS/PREP_COUNTERTOPS (deep = over 3 mm; shallow bridges under primer)"
   },
   {
    "id": "plywood-prep",
    "tab": "guided",
    "severity": "warn",
    "substrates": [
     "plywood"
    ],
    "attach_to": "ardex-x-5",
    "message": "Skim coat Ardex X5, 1 to 2 mm, with Ardex SK Mesh embedded at the seams. Use 3/4 inch (19 mm) minimum, thinner sheets flex and crack the finish.",
    "_source": "technical-facts.md field-verified corrections (full float 2026-08-27) + X5 skim ruling 2026-08-29 + Decork coatings over plywood (SK Mesh at seams) + install-steps PREP_GENERAL/PREP_FLOORS (19 mm minimum)"
   },
   {
    "id": "lap-siding-joints",
    "tab": "guided",
    "severity": "warn",
    "systems": [
     "cork-walls-exterior"
    ],
    "substrates": [
     "wood-lap-siding"
    ],
    "message": "Lap siding works under Decork Façade with one addition: run Diaseal Strong under and along the laps first, then prime. Wood dry, cohesive and dimensionally stable.",
    "_source": "technical-facts.md Decork Facade over wood lap siding (J. Nelson 2026-08-29)"
   },
   {
    "id": "dry-concrete-vapour",
    "tab": "guided",
    "severity": "info",
    "systems": [
     "floors",
     "walls",
     "countertops",
     "fireplaces"
    ],
    "substrates": [
     "concrete-dry"
    ],
    "message": "Concrete that reads dry (under 5% moisture) still takes WATstop at 1 kg/m² as the vapour barrier. WATstop bonds straight to the concrete; nothing is primed under it.",
    "_source": "technical-facts.md WATstop dry-substrate threshold + Primers (never Grip Primer beneath WATstop)"
   },
   {
    "id": "damp-concrete-route",
    "tab": "guided",
    "severity": "info",
    "systems": [
     "showers",
     "floors",
     "walls",
     "fireplaces",
     "patios"
    ],
    "substrates": [
     "concrete-damp"
    ],
    "message": "At 5% moisture or more, WATstop goes on at 2 kg/m² in two coats, bonded straight to the concrete. Nothing is primed under WATstop.",
    "_source": "technical-facts.md Primers (wet areas 2 kg/m²) + moisture routing <5%/>=5%"
   },
   {
    "id": "kerdi-start",
    "tab": "guided",
    "severity": "info",
    "systems": [
     "showers"
    ],
    "substrates": [
     "kerdi"
    ],
    "message": "Kerdi Board carries the waterproofing but still needs to be primed with Grip Primer to start.",
    "_source": "stage-data showers routing (kerdi-board list has no WATstop)"
   },
   {
    "id": "movement-joints",
    "tab": "guided",
    "severity": "info",
    "systems": [
     "floors",
     "patios"
    ],
    "always": true,
    "message": "Movement and control joints stay flexible. Diaseal Strong fills the joint and Safety Joint Roll bridges it, embedded in WATstop.",
    "_source": "technical-facts.md Joint treatments (movement joints, J. Nelson 2026-08-27)"
   },
   {
    "id": "countertop-food-safety",
    "tab": "guided",
    "severity": "warn",
    "systems": [
     "countertops",
     "furniture"
    ],
    "always": true,
    "message": "Once fully cured, microcement handles everyday use: a cutting board when prepping food on counters, placemats on tables. The finish takes 5 to 7 days to reach full cure before regular use.",
    "_source": "canon.yaml countertops/furniture notes (kitchen-use line, J. Nelson 2026-11-03) + technical-facts.md Decorkrete reformulation table (7 days full cure)"
   },
   {
    "id": "fireplace-flame-limit",
    "tab": "guided",
    "severity": "warn",
    "systems": [
     "fireplaces"
    ],
    "always": true,
    "message": "Keep the finish outside the firebox and off any surface flame touches.",
    "_source": "stage-data fireplaces note (NOT FOR DIRECT FLAME CONTACT, radiant heat only)"
   },
   {
    "id": "patio-weather-window",
    "tab": "guided",
    "severity": "info",
    "systems": [
     "patios"
    ],
    "always": true,
    "message": "Outdoor work runs between +5 and +30°C, substrate included, and the system stays protected from rain until fully cured.",
    "_source": "technical-facts.md Product-library policies (+5/+30 envelope) + stage-data patios note (rain protection; its +35 ceiling is superseded by the envelope ruling)"
   },
   {
    "id": "watstop-overcoat-window",
    "tab": "guided",
    "severity": "info",
    "systems": [
     "showers",
     "patios"
    ],
    "always": true,
    "route_has": "watstop",
    "message": "WATstop has a 2-hour pot life, plan your project carefully to only take on what you can apply in that amount of time. Decorkrete needs to be applied within 48 hours of the final WATstop coat.",
    "_source": "stage-data showers note (pot life 2 h, overcoat 48 h)"
   },
   {
    "id": "watstop-overcoat-concrete",
    "tab": "guided",
    "severity": "info",
    "systems": [
     "floors",
     "walls",
     "countertops",
     "fireplaces"
    ],
    "substrates": [
     "concrete"
    ],
    "route_has": "watstop",
    "message": "WATstop has a 2-hour pot life, plan your project carefully to only take on what you can apply in that amount of time. Decorkrete needs to be applied within 48 hours of the final WATstop coat.",
    "_source": "stage-data showers note (pot life 2 h, overcoat 48 h); fires on the concrete routes, which all open with WATstop"
   },
   {
    "id": "limepaint-needs-d20",
    "tab": "quick",
    "severity": "info",
    "all_of": [
     "limepaint"
    ],
    "missing": [
     "d20"
    ],
    "message": "Limepaint needs D20 only over a highly absorbent surface like plaster or Diathonite. Over unpainted drywall it needs nothing; over painted drywall, a regular water-based primer first. Limepaint stays indoors.",
    "_source": "J. Nelson field correction 2026-09-07 (D20 conditional on substrate absorbency, not universal - see technical-facts.md finish-paint entry) + Limepaint TDS interior-only line"
   },
   {
    "id": "plasterpaint-needs-d20",
    "tab": "quick",
    "severity": "info",
    "all_of": [
     "plasterpaint-coloured"
    ],
    "missing": [
     "d20"
    ],
    "message": "Plasterpaint Coloured needs D20 only over a highly absorbent surface. Over previously painted masonry, Grip Primer goes first.",
    "_source": "J. Nelson field correction 2026-09-07 (D20 conditional; previously-painted masonry primes with Grip Primer - see technical-facts.md finish-paint entry)"
   },
   {
    "id": "diathonite-primer",
    "tab": "quick",
    "severity": "warn",
    "all_of": [
     "grip-primer"
    ],
    "any_of": [
     "diathonite-thermactive-037",
     "diathonite-evolution",
     "diathonite-deumix",
     "diathonite-acoustix-plus"
    ],
    "message": "Where a Diathonite render needs a primer, the primer is Aquabond. Sound rough concrete takes no primer at all; a flaking or dusty wall gets washed, then full-surface Aquabond. Grip Primer belongs to the microcement or cork side of the job.",
    "_source": "technical-facts.md Primers (Aquabond for Diathonite) + Aquabond on compromised walls (2026-08-29; scoped to the four wall renders - Sismactive is exempt, inconsistent plaster is demolished, so it stays out of any_of)"
   },
   {
    "id": "deumix-system-minimum",
    "tab": "quick",
    "severity": "warn",
    "all_of": [
     "watstop",
     "diathonite-deumix"
    ],
    "message": "The basement dehumidifying system runs Deumix+ at 25 mm minimum (11 kg/m², one pass) over WATstop, applied within 24 to 48 hours of the last WATstop coat with nothing primed between.",
    "_source": "technical-facts.md WATstop + Deumix dehumidifying system (25 mm system spec overrides the 15 mm table minimum; fresh-on-fresh bond, no primer)"
   },
   {
    "id": "argatherm-sandwich",
    "tab": "quick",
    "severity": "warn",
    "all_of": [
     "argatherm"
    ],
    "any_of": [
     "diathonite-thermactive-037",
     "diathonite-evolution",
     "diathonite-deumix",
     "diathonite-acoustix-plus"
    ],
    "missing": [
     "polites-80"
    ],
    "message": "Over a Diathonite render, Argatherm waits 15 days and goes on as a sandwich: Argatherm, Polites 80 embedded wet, then Argatherm, at 1.5 mm max per layer. Add the mesh to this quote.",
    "_source": "technical-facts.md finish-route timings (15 days; sandwich with Polites 80, max 1.5 mm/layer, 3 mm total)"
   },
   {
    "id": "decork-needs-seal",
    "tab": "quick",
    "severity": "info",
    "any_of": [
     "decork-facade",
     "decork-mediterraneo"
    ],
    "missing": [
     "aquafloor-eco"
    ],
    "message": "Unsealed, the Decork coatings are dry wall and facade finishes. On a floor, counter or wet area they seal with Aquafloor Eco, which also closes their breathability.",
    "_source": "technical-facts.md field-verified corrections (Decork + Aquafloor serve the microcement surfaces, J. Nelson 2026-08-28; sealed system is waterproof, breathability closed)"
   },
   {
    "id": "seal-needs-d20",
    "tab": "quick",
    "severity": "warn",
    "all_of": [
     "decorkrete",
     "aquafloor-eco"
    ],
    "missing": [
     "d20"
    ],
    "message": "The Decorkrete systems require D20 first, then Aquafloor Eco. Add D20.",
    "_source": "stage-data system routing (every quotable Decorkrete list runs d20 then aquafloor-eco; pools seal with Pool Protector and are excluded from the tool) + technical-facts.md finish routes"
   },
   {
    "id": "decorkrete-needs-base",
    "tab": "quick",
    "severity": "warn",
    "all_of": [
     "decorkrete"
    ],
    "missing": [
     "grip-primer",
     "watstop"
    ],
    "message": "Decorkrete starts on a primed base: Grip Primer or WATstop depending on substrate and moisture.",
    "_source": "technical-facts.md Primers + stage-data routing (every list opens with one of the two; dry concrete routes to WATstop, Kerdi to Grip Primer)"
   },
   {
    "id": "acriflex-primer-scope",
    "tab": "quick",
    "severity": "info",
    "all_of": [
     "acriflex-primer"
    ],
    "message": "Acriflex Primer impregnates porous asbestos-cement. On vinyl asbestos tile the bond coat is Grip Primer.",
    "_source": "technical-facts.md Asbestos encapsulation (Advisory No. 05, 2026-07-27)"
   }
  ]
 },
 "ui": {
  "common": {
   "check": "Check",
   "note": "Note",
   "out_of_stock": "Out of stock",
   "unit_ft2": " ft²",
   "unit_m2": " m²",
   "sq_ft": "sq ft",
   "sep": " · "
  },
  "quick": {
   "tab": "Quick Order",
   "intro": "Order by product at your trade rate.",
   "intro_link": "Building a whole system? Use the Guided Builder",
   "loading": "Loading products",
   "failed": "{name} did not load.",
   "retry": "Try again",
   "search_placeholder": "Search by product, SKU, size or job",
   "search_clear": "Clear search",
   "no_results": "Nothing matches \"{q}\". Try a product name, a SKU, a size or a job.",
   "size_field": "Size",
   "colour_field": "Colour",
   "coats_field": "Coats",
   "thickness_field": "Thickness",
   "thickness_label": "Thickness, {name}",
   "mm": "{n} mm",
   "in_quote": "{n} in quote",
   "ask_size": "Ask about this size",
   "ask_subject": "Trade quote: {name}",
   "size_label": "Project size",
   "size_placeholder": "Area",
   "size_hint": "Each card's quantity follows your size. Leave it blank to set quantities yourself.",
   "all": "All",
   "all_products": "All products",
   "product_count": "{n} product{s}",
   "size_standard": "Standard",
   "variant_oos": " (Out of stock)",
   "unit_oos": " · Out of stock",
   "colour_placeholder": "Choose a colour",
   "coats_label": "Coats, {name}",
   "fewer": "Fewer {name}",
   "more": "More {name}",
   "quantity": "Quantity, {name}",
   "add": "+ Add",
   "added": "✓ Added",
   "cover": "For {size}: {qty} × {per} ({basis})",
   "cover_alts": " · or {list}",
   "alts_sep": " / ",
   "cover_fit": " · cheapest fit: {combo}",
   "combo_join": " + ",
   "fit_add": "+ Add both",
   "toast_fit": "✓ Added both sizes, {title}",
   "cover_capped": " Capped at 999; call us for pallet quantities.",
   "cover_thickness": "Needs a thickness. Use the Guided Builder.",
   "cover_manual": "Set the quantity yourself.",
   "basis_kg": "{kg} kg at {rate}, 10% waste",
   "basis_roll": "{m2} m² incl. 10% overlap and 10% waste",
   "per_roll": "roll",
   "per_kg": "kg",
   "toast_oos": "That size is out of stock",
   "toast_colour": "Choose a colour first",
   "colour_error": "Choose a colour to add this product.",
   "colour_chart": "Colour chart",
   "data_sheet": "Data sheet",
   "covers": "{size} covers {m2} m² / {ft2} ft² at {coats} coat{s}",
   "covers_thick": "{size} covers {m2} m² / {ft2} ft² at {mm} mm",
   "covers_linear": "One {per} covers {m} m / {ft} ft",
   "covers_roll": "One roll covers {m2} m² / {ft2} ft²",
   "oos_lead": "Special order: ships in {weeks}.",
   "usual_title": "Your usual",
   "usual_hint": "Your last {n} order{s}. Load one and every line comes in at today's rate.",
   "usual_lines": "{n} line{s}",
   "usual_load": "Load into quote",
   "usual_loading": "Loading",
   "usual_loaded": "Loaded {n} line{s} from order {order}",
   "usual_skipped": "{n} line{s} from that order {isare} no longer sold and {wasWere} left out.",
   "toast_set": "{title} set to {qty}",
   "toast_added_qty": "Added {qty} × {title} to quote",
   "toast_added": "Added {title} to quote"
  },
  "guided": {
   "tab": "Guided Builder",
   "pick_line": "Pick the product line, then the project.",
   "pick_project": "Choose what you're finishing. We route the products and quantities for your substrate.",
   "project_count": "{n} project{s}",
   "all_lines": "← All product lines",
   "back": "← Back to systems",
   "area_label": "Area",
   "area_placeholder": "Area",
   "substrate_label": "Substrate",
   "substrate_placeholder": "Choose what's under it",
   "thickness_label": "Thickness",
   "waste_label": "Waste",
   "colour_label": "Colour:",
   "empty_substrate": "Pick the substrate to see the products and quantities for this system.",
   "prep_title": "Prep",
   "prep_hint": "Goes on before the first coat. Switch off what this job does not need.",
   "before_title": "Before you start",
   "guide_new_tab": "Opens in a new tab",
   "colour_placeholder": "Choose a colour",
   "chart": "Colour chart",
   "chart_alt": "Colour chart",
   "colour_group": "Colours",
   "colour_error": "Choose a colour before adding this system.",
   "stepper_counts": "The stepper counts {size} containers.",
   "empty": "Enter an area to see the products and quantities for this system.",
   "loading": "Loading the products for this system.",
   "toast_loading": "The products are still loading",
   "toast_substrate": "Choose the substrate first",
   "toast_failed": "Some products did not load. Try again first.",
   "step": "STEP {n}",
   "optional": "OPTIONAL",
   "step_off": "Off",
   "each": "{price} ea",
   "mixed": "mixed sizes",
   "linear_label": "Your {unit}:",
   "linear_hint": "Estimate. Measure to confirm.",
   "per_area": "{ft2} / ft²  •  {m2} / m²",
   "steps_title": "Installation steps",
   "guide_open": "Get your installation guide",
   "total_label": "System total",
   "add": "Add system to quote",
   "added": "Added to your quote",
   "toast_pick": "Pick a system first",
   "toast_area": "Enter an area first",
   "toast_colour": "Choose a colour first",
   "toast_added": "{system} added: {lines} line{s}, {items} item{is}"
  },
  "panel": {
   "title": "Your quote",
   "empty_title": "Ready when you are",
   "empty_hint": "Add products to start your quote",
   "colour": "Colour: {colour}",
   "each": "{price} each",
   "province": "Province",
   "subtotal": "Subtotal",
   "total": "Total",
   "clear": "Clear quote",
   "clear_confirm": "Clear the quote?",
   "remove_line": "Remove {name}",
   "individual": "Individual products",
   "room_label": "Room",
   "room_default": "{system} {n}",
   "group_remove": "Remove {room}",
   "job_label": "Job",
   "job_placeholder": "Job name or site",
   "resumed": "Quote resumed from {when}",
   "resume_dropped": "{n} line{s} {wasWere} left out: that size is no longer sold.",
   "resume_dismiss": "Keep it",
   "start_fresh": "Start fresh",
   "thickness": "Thickness: {mm}",
   "stale": "Price to confirm",
   "count_sr": " item{s} in quote",
   "tool_title": "Trade quote",
   "empty_hint_guided": "Pick a system and add it to start your quote",
   "view_quote": "View quote",
   "mobile_count": "{n} item{s}",
   "tier_note_cart": "Prices shown are your {tier} rates. Taxes estimated by province; checkout confirms.",
   "tier_note_quote": "Prices shown at your {tier} rate. Send the quote and we draft your order at these prices.",
   "sent_badge": "Sent",
   "mobile_sent": "Quote {ref} sent",
   "ref_aria": "Reference on this page",
   "ref_charts": "Colour charts",
   "ref_sheets": "Data sheets",
   "ref_samples": "Order samples",
   "ref_contact": "Contact",
   "ship_free": "Free shipping across Canada on this order.",
   "ship_away": "{amount} more for free shipping across Canada.",
   "ship_within": "In-stock orders ship within {days}.",
   "note_add": "Add a note",
   "note_placeholder": "Room, sample to match, delivery instructions",
   "note_label": "Note for {name}",
   "print": "Print quote",
   "print_title": "Eco-Tech Building Solutions",
   "print_date": "Date",
   "print_customer": "Customer",
   "print_tier": "Pricing",
   "print_tier_value": "{tier} rate. Prices valid {days} days.",
   "print_job": "Job",
   "print_province": "Province",
   "print_ref": "Quote"
  },
  "rep": {
   "customer_title": "Who is this for",
   "customer_search": "Search customers by name, company or email",
   "customer_search_hint": "Already a customer? Search and their details load in. Otherwise type them below.",
   "customer_searching": "Searching...",
   "customer_none": "No match. Type their details instead.",
   "customer_picked": "{name} loaded from the store.",
   "customer_clear": "Clear customer",
   "customer_tier_found": "This account is on the {tier} rate, {pct} percent.",
   "name": "Customer name",
   "company": "Company (optional)",
   "email": "Email",
   "phone": "Phone",
   "address": "Project address",
   "colour_code": "Colour (e.g. S25)",
   "notes": "Notes (scope, special requests)",
   "quote_number": "Quote number (fills in)",
   "email_bad": "This address is not complete. Fix it, or clear it if you do not have one.",
   "email_typo": "Did you mean {domain}?",
   "email_blocked": "Check the email address before creating the link.",
   "services_title": "Additional services",
   "services_hint": "Freight, site visits, prep labour. Taxable unless you say otherwise.",
   "services_add": "Add a service",
   "service_label": "What it is",
   "service_price": "Price",
   "service_qty": "Qty",
   "service_taxable": "Taxable",
   "service_discountable": "Discount applies",
   "service_remove": "Remove this service",
   "services_none": "No services on this quote yet.",
   "discount_title": "Pricing",
   "discount_tier": "Rate",
   "discount_own": "Or set your own",
   "discount_pct": "Percent off",
   "discount_show": "Show the discount to the customer",
   "discount_show_hint": "Off means they see the lower prices without a discount line.",
   "discount_row": "Discount ({pct}%)",
   "saved_row": "You saved ({pct}%)",
   "discount_high_confirm": "That is {pct} percent off. Are you sure?",
   "discount_applied": "Priced at the {tier} rate, {pct} percent off.",
   "discount_none": "Priced at retail.",
   "tier_retail": "Retail",
   "tier_trade": "Trade",
   "tier_pro": "Pro",
   "tier_partner": "Partner",
   "tier_elite": "Elite",
   "subtotal_services": "Services",
   "create": "Create quote link",
   "create_again": "Update the quote",
   "creating": "Saving the quote...",
   "link_title": "Quote {number}",
   "link_hint": "Send this to your customer. They see the quote, not an invoice.",
   "link_copy": "Copy link",
   "link_copied": "Link copied",
   "link_copied_rich": "Copied as a link. Paste it into your email.",
   "link_text": "Your quote is ready",
   "link_text_named": "{name}, your quote is ready",
   "link_open": "Open it yourself",
   "link_revoke": "Revoke",
   "link_revoked": "This link no longer works.",
   "link_revoke_confirm": "Revoke this link? The customer will not be able to open it.",
   "link_status_sent": "Sent, not opened yet",
   "link_status_viewed": "Opened by the customer",
   "link_status_accepted": "Accepted",
   "link_expires": "Good until {date}",
   "create_failed": "The quote could not be saved, so there is no link yet. Try again.",
   "create_not_staff": "Your account is not set up to send quotes. Ask Admin to add the staff tag.",
   "create_empty": "Add a product or a service first.",
   "create_gone": "One of these is no longer for sale: {names}. Remove it and try again.",
   "unusual_saved": "Saved at {pct} percent off. That is unusual, so it is flagged in admin.",
   "list_title": "Recent quotes",
   "list_hint": "The last ones you sent. Refresh to see what has happened since.",
   "list_refresh": "Refresh",
   "list_refreshing": "Checking",
   "list_none": "Nothing yet. Quotes you create land here.",
   "list_failed": "The list could not be loaded. Try refresh.",
   "list_delete": "Delete quote {number}",
   "list_delete_confirm": "Delete {number} permanently? The link stops working and it leaves this list. This cannot be undone.",
   "list_delete_failed": "That quote could not be deleted. Refresh and try again.",
   "list_deleted": "Quote {number} deleted.",
   "list_locked": "Accepted and waiting on its draft order, so it cannot be deleted yet",
   "list_lines": "{n} line{s}",
   "list_status_sent": "Sent {age}, not opened yet",
   "list_status_viewed": "Opened {age}",
   "list_status_accepted": "Accepted {age}, draft not made yet",
   "list_status_ordered": "Accepted {age}, draft {draft} waiting",
   "list_status_revoked": "Revoked",
   "list_status_expired": "Expired",
   "list_age_days": "{n} day{s} ago",
   "list_age_hours": "{n} hour{s} ago",
   "list_age_now": "just now",
   "print_prepared": "Prepared by",
   "print_for": "Prepared for",
   "print_quote_no": "Quote"
  },
  "checkout": {
   "add_all": "Add all to cart",
   "adding": "Adding to cart...",
   "order_quote": "Order through your quote",
   "empty": "Add products first",
   "elite": "Quotes cannot be sent from here right now. Email your job name to info@ecotechnology.ca or call 1-866-326-8321, and we'll draft your order at your Elite prices.",
   "holds": "Your cart already holds {n} item{s}. ",
   "keep": "Add this quote to it",
   "replace": "Replace it with this quote",
   "add_error": "Nothing was added to your cart{detail}. Try again, or call us at 1-866-326-8321.",
   "sending": "Sending your quote...",
   "send_again": "Send again",
   "sent_title": "Quote {ref} sent",
   "sent_replay_title": "Quote {ref} was already sent",
   "sent_meta": "{job} · {n} line{s} · {total} with tax, before freight",
   "sent_meta_nojob": "{n} line{s} · {total} with tax, before freight",
   "sent_body_rep": "Your order is drafted at your Elite prices. We confirm stock and freight, then email your invoice to {email}, usually within one business day. Pay from that email and your order ships, or call 1-866-326-8321 and quote {ref}.",
   "sent_body_invoice": "Your invoice at your Elite prices is on its way to {email}. Pay from that email and your order ships, or call 1-866-326-8321 and quote {ref}.",
   "sent_replay": "Nothing was sent twice.",
   "sent_inventory": "Some of these items are short in stock. We confirm lead times with your invoice.",
   "sent_address": "Tax is estimated until we confirm your shipping address.",
   "sent_drift": "Store prices changed since you built this quote. Your invoice carries the current prices.",
   "sent_print": "Print this quote",
   "sent_new": "Start a new quote",
   "rep_blocked": "This is a rep quote. Send it to the customer instead: the cart cannot carry your discount.",
   "send_unreachable": "We could not reach the quote service, so nothing was sent. Your quote is saved on this device.",
   "send_unconfirmed": "We could not confirm your quote was received. Press Send again; the same quote is never created twice. Or call 1-866-326-8321 and quote your job name.",
   "send_signin": "Your sign-in has expired, so nothing was sent. {link} and press the button again; your quote is saved on this device.",
   "send_signin_link": "Sign in",
   "send_refused": "This quote could not be sent from this account. Call 1-866-326-8321 or email info@ecotechnology.ca and we will place the order for you.",
   "send_unavailable": "The quote service is not available right now. Email your job name and this quote to info@ecotechnology.ca, or call 1-866-326-8321, and we will draft the order for you.",
   "send_line_gone": "A line is no longer sold as quoted: {names}. Remove it or change the size, then send again.",
   "send_stale": "This page is out of date. Reload it and send again; your quote is saved on this device.",
   "send_too_many": "Too many quotes were sent from this account in the last hour. Call 1-866-326-8321 and we will place the order.",
   "send_code": "Reference code {code}.",
   "sent_locked": "This quote is with us. Start a new quote to add to it."
  }
 },
 "page": {
  "anchors": {
   "colour_chart": "trade_colours",
   "data_sheets": "trade_docs",
   "contact": {
    "section": "trade_docs",
    "part": ".systems-docs__contact"
   },
   "samples": {
    "section": "trade_colours",
    "part": ".systems-colors__sample-button"
   }
  },
  "links": {
   "samples": "/collections/samples"
  },
  "data_sheets": [
   "decorkrete",
   "watstop",
   "grip-primer",
   "d20",
   "aquafloor-eco",
   "ultragum",
   "bkk-eco",
   "c-w-c-stop-conden",
   "diaseal-strong",
   "decork-facade"
  ]
 },
 "noDiscountSkus": [
  "DK-SMPL",
  "DK-BRD-SML",
  "DK-BRD-LRG"
 ],
 "systems": [
  {
   "key": "showers",
   "name": "Showers & Wet Areas",
   "icon": "🚿",
   "subtitle": "WATstop + Decorkrete wet-area system",
   "guide_key": "microcement",
   "show_thickness": false,
   "default_thickness_mm": 20,
   "substrates": [
    "Moisture Resistant Drywall",
    "Concrete (Dry)",
    "Concrete (Damp≥5%)",
    "Tile",
    "Cement Board",
    "Kerdi Board"
   ],
   "products": {
    "default": [
     {
      "id": "watstop",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ],
    "concrete-damp-5": [
     {
      "id": "watstop",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ],
    "tile": [
     {
      "id": "ardex-x-5",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "watstop",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ],
    "cement-board": [
     {
      "id": "ardex-x-5",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "watstop",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ],
    "kerdi-board": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ]
   },
   "colors": [
    "S21",
    "S25",
    "S26",
    "TB2",
    "Natural",
    "T22"
   ],
   "color_chart": "https://ecotechnology.ca/cdn/shop/files/Colors3.jpg",
   "color_products": [
    "decorkrete"
   ],
   "family": "microcement",
   "note": "WATstop pot life is ONLY 2 hours. Apply Decorkrete within 48h of final WATstop coat."
  },
  {
   "key": "floors",
   "name": "Floors",
   "icon": "🏠",
   "subtitle": "Decorkrete floor system",
   "guide_key": "microcement",
   "show_thickness": false,
   "default_thickness_mm": 20,
   "substrates": [
    "Concrete (Dry)",
    "Concrete (Damp≥5%)",
    "Tile",
    "Plywood"
   ],
   "products": {
    "default": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ],
    "concrete-dry": [
     {
      "id": "watstop",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ],
    "concrete-damp-5": [
     {
      "id": "watstop",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ]
   },
   "colors": [
    "S21",
    "S25",
    "S26",
    "TB2",
    "Natural",
    "T22"
   ],
   "color_chart": "https://ecotechnology.ca/cdn/shop/files/Colors3.jpg",
   "color_products": [
    "decorkrete"
   ],
   "family": "microcement",
   "note": "For high-traffic areas, consider additional sealer coats."
  },
  {
   "key": "countertops",
   "name": "Countertops & Backsplashes",
   "icon": "🍽️",
   "subtitle": "Decorkrete countertop system",
   "guide_key": "microcement",
   "show_thickness": false,
   "default_thickness_mm": 20,
   "substrates": [
    "Laminate",
    "Concrete (Dry)",
    "Tile",
    "Cement Board",
    "Plywood",
    "Natural Stone"
   ],
   "products": {
    "default": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ]
   },
   "colors": [
    "S21",
    "S25",
    "S26",
    "TB2",
    "Natural",
    "T22"
   ],
   "color_chart": "https://ecotechnology.ca/cdn/shop/files/Colors3.jpg",
   "color_products": [
    "decorkrete"
   ],
   "family": "microcement",
   "note": ""
  },
  {
   "key": "walls",
   "name": "Interior/Exterior Walls",
   "icon": "🧱",
   "subtitle": "Decorkrete wall system",
   "guide_key": "microcement",
   "show_thickness": false,
   "default_thickness_mm": 20,
   "substrates": [
    "Drywall",
    "Existing Paint",
    "Concrete (Dry)",
    "Concrete (Damp≥5%)",
    "Tile",
    "Cement Board",
    "Plywood"
   ],
   "products": {
    "default": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ],
    "concrete-dry": [
     {
      "id": "watstop",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ],
    "concrete-damp-5": [
     {
      "id": "watstop",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ]
   },
   "colors": [
    "Natural",
    "S21",
    "S25",
    "S26",
    "TB2",
    "T22"
   ],
   "color_chart": "https://ecotechnology.ca/cdn/shop/files/Colors3.jpg",
   "color_products": [
    "decorkrete"
   ],
   "family": "microcement",
   "note": "Use stiffer mix (less water) for vertical surfaces."
  },
  {
   "key": "fireplaces",
   "name": "Fireplaces & Range Hoods",
   "icon": "🔥",
   "subtitle": "Decorkrete surround system",
   "guide_key": "microcement",
   "show_thickness": false,
   "default_thickness_mm": 20,
   "substrates": [
    "Metal",
    "Drywall",
    "Concrete (Dry)",
    "Concrete (Damp≥5%)",
    "Tile",
    "Cement Board",
    "Plywood"
   ],
   "products": {
    "default": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ],
    "concrete-damp-5": [
     {
      "id": "watstop",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ]
   },
   "colors": [
    "Natural",
    "S21",
    "S25",
    "S26",
    "TB2",
    "T22"
   ],
   "color_chart": "https://ecotechnology.ca/cdn/shop/files/Colors3.jpg",
   "color_products": [
    "decorkrete"
   ],
   "family": "microcement",
   "note": ""
  },
  {
   "key": "furniture",
   "name": "Tables & Furniture",
   "icon": "🪑",
   "subtitle": "Decorkrete furniture system",
   "guide_key": "microcement",
   "show_thickness": false,
   "default_thickness_mm": 20,
   "substrates": [
    "Wood",
    "Metal",
    "Laminate"
   ],
   "products": {
    "default": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ]
   },
   "colors": [
    "Natural",
    "S21",
    "S25",
    "S26",
    "TB2",
    "T22"
   ],
   "color_chart": "https://ecotechnology.ca/cdn/shop/files/Colors3.jpg",
   "color_products": [
    "decorkrete"
   ],
   "family": "microcement",
   "note": ""
  },
  {
   "key": "patios",
   "name": "Outdoor Patios & Terraces",
   "icon": "☀️",
   "subtitle": "WATstop + Decorkrete exterior system",
   "guide_key": "microcement",
   "show_thickness": false,
   "default_thickness_mm": 20,
   "substrates": [
    "Concrete (Dry)",
    "Concrete (Damp≥5%)",
    "Tile",
    "Plywood"
   ],
   "products": {
    "default": [
     {
      "id": "watstop",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "decorkrete",
      "coats": 2,
      "thicknessDependent": false
     },
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "aquafloor-eco",
      "coats": 3,
      "thicknessDependent": false
     }
    ]
   },
   "colors": [
    "Natural",
    "S21",
    "S25",
    "S26",
    "TB2",
    "T22"
   ],
   "color_chart": "https://ecotechnology.ca/cdn/shop/files/Colors3.jpg",
   "color_products": [
    "decorkrete"
   ],
   "family": "microcement",
   "note": "Apply between +5C and +30C. Protect from rain until cured."
  },
  {
   "key": "cork-walls-exterior",
   "name": "Cork Exterior Walls",
   "icon": "🌳",
   "subtitle": "Decork Facade coating",
   "guide_key": "cork-walls",
   "show_thickness": false,
   "default_thickness_mm": 20,
   "substrates": [
    "Sound Render / Old Plaster",
    "New Plaster / Diathonite",
    "Concrete (Damp or Rough)",
    "Wood",
    "Wood Lap Siding",
    "Plywood"
   ],
   "products": {
    "default": [
     {
      "id": "decork-facade",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "new-plaster-diathonite": [
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-facade",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "concrete-damp-or-rough": [
     {
      "id": "watstop",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-facade",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "wood": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-facade",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "wood-lap-siding": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-facade",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "plywood": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-facade",
      "coats": 2,
      "thicknessDependent": false
     }
    ]
   },
   "colors": [
    "UB1",
    "TB1",
    "T23",
    "T2D",
    "TBS",
    "T25",
    "T26",
    "T27",
    "T28",
    "TBM",
    "T32",
    "T2U",
    "T2I",
    "T2V",
    "T2L",
    "TC3",
    "TBA",
    "TBN",
    "T21",
    "T22",
    "TB2",
    "T34",
    "TBQ",
    "TBJ",
    "T37",
    "Natural"
   ],
   "color_chart": "https://cdn.shopify.com/s/files/1/0558/2723/5006/files/Decork_Facade_Colour_Chart.jpg?v=1788040288",
   "color_products": [
    "decork-facade"
   ],
   "family": "cork",
   "note": "Exterior walls in high-moisture regions: BKK Eco can be added over the finish as additional water repellent."
  },
  {
   "key": "cork-walls-interior",
   "name": "Cork Interior Walls",
   "icon": "🌿",
   "subtitle": "Decork Mediterraneo coating",
   "guide_key": "cork-walls",
   "show_thickness": false,
   "default_thickness_mm": 20,
   "substrates": [
    "Plaster (Sound)",
    "Drywall / Plasterboard",
    "New Plaster / Diathonite",
    "Concrete (Smooth, Dry)",
    "Concrete (Damp or Rough)",
    "Tile",
    "Cement Board",
    "Wood",
    "Plywood",
    "Metal"
   ],
   "products": {
    "default": [
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "plasterboard": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "drywall": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "new-plaster-diathonite": [
     {
      "id": "d20",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "concrete-smooth-dry": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "concrete-damp-or-rough": [
     {
      "id": "watstop",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "tile": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "cement-board": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "wood": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "plywood": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ],
    "metal": [
     {
      "id": "grip-primer",
      "coats": 1,
      "thicknessDependent": false
     },
     {
      "id": "decork-mediterraneo",
      "coats": 2,
      "thicknessDependent": false
     }
    ]
   },
   "colors": [
    "Giallo Ercolano",
    "Rosa Camargue",
    "Rosso Pompei",
    "Verde Gibilterra",
    "Tortora Otranto",
    "Arancio Taormina",
    "Bianco Ostuni 24",
    "Grigio Spalato",
    "Blu Alessandria d'Egitto"
   ],
   "color_chart": "https://cdn.shopify.com/s/files/1/0558/2723/5006/files/MED-swatches-overhead-with-labels.png?v=1778604261",
   "color_products": [
    "decork-mediterraneo"
   ],
   "family": "cork",
   "note": "Interior walls in high-traffic locations: seal with Aquafloor Eco."
  }
 ],
 "productColors": {
  "decorkrete": {
   "colors": [
    "S21",
    "S25",
    "S26",
    "TB2",
    "Natural",
    "T22"
   ],
   "chart": "https://ecotechnology.ca/cdn/shop/files/Colors3.jpg"
  },
  "decork-facade": {
   "colors": [
    "UB1",
    "TB1",
    "T23",
    "T2D",
    "TBS",
    "T25",
    "T26",
    "T27",
    "T28",
    "TBM",
    "T32",
    "T2U",
    "T2I",
    "T2V",
    "T2L",
    "TC3",
    "TBA",
    "TBN",
    "T21",
    "T22",
    "TB2",
    "T34",
    "TBQ",
    "TBJ",
    "T37",
    "Natural"
   ],
   "chart": "https://cdn.shopify.com/s/files/1/0558/2723/5006/files/Decork_Facade_Colour_Chart.jpg?v=1788040288"
  },
  "decork-mediterraneo": {
   "colors": [
    "Giallo Ercolano",
    "Rosa Camargue",
    "Rosso Pompei",
    "Verde Gibilterra",
    "Tortora Otranto",
    "Arancio Taormina",
    "Bianco Ostuni 24",
    "Grigio Spalato",
    "Blu Alessandria d'Egitto"
   ],
   "chart": "https://cdn.shopify.com/s/files/1/0558/2723/5006/files/MED-swatches-overhead-with-labels.png?v=1778604261"
  }
 },
 "stepGuides": {
  "showers": {
   "guideKey": "microcement",
   "defaultSteps": [
    "MATERIALS_NEEDED",
    "PREP_WET_AREAS",
    "WATSTOP1KG_APPLY",
    "JOINTS",
    "DECORKRETE_APPLY",
    "DECORKRETE_SAND",
    "DUST_REMOVAL",
    "D20_PRIMER",
    "AQUAFLOOR_SEAL"
   ],
   "substrateOverrides": {
    "moisture-resistant-drywall": [
     "MATERIALS_NEEDED",
     "PREP_WET_AREAS",
     "ARDEX_X5_CEMENT_BOARD",
     "WATSTOP1KG_APPLY",
     "JOINTS",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "cement-board": [
     "MATERIALS_NEEDED",
     "PREP_WET_AREAS",
     "ARDEX_X5_CEMENT_BOARD",
     "WATSTOP1KG_APPLY",
     "JOINTS",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "tile": [
     "MATERIALS_NEEDED",
     "PREP_WET_AREAS",
     "ARDEX_X5",
     "WATSTOP1KG_APPLY",
     "JOINTS",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "kerdi-board": [
     "MATERIALS_NEEDED",
     "PREP_WET_AREAS",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "concrete-damp-5": [
     "MATERIALS_NEEDED",
     "PREP_WET_AREAS",
     "WATSTOP2KG_APPLY",
     "JOINTS",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ]
   }
  },
  "floors": {
   "guideKey": "microcement",
   "defaultSteps": [
    "MATERIALS_NEEDED",
    "PREP_FLOORS",
    "EXPANSION_JOINTS",
    "WATSTOP_FLOORS_1KG",
    "DECORKRETE_APPLY",
    "DECORKRETE_SAND",
    "DUST_REMOVAL",
    "D20_PRIMER",
    "AQUAFLOOR_SEAL"
   ],
   "substrateOverrides": {
    "concrete-damp-5": [
     "MATERIALS_NEEDED",
     "PREP_FLOORS",
     "EXPANSION_JOINTS",
     "WATSTOP_FLOORS_2KG",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "plywood": [
     "MATERIALS_NEEDED",
     "PREP_FLOORS",
     "GRIP_PRIMER",
     "ARDEX_X5",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "tile": [
     "MATERIALS_NEEDED",
     "PREP_FLOORS",
     "ARDEX_X5",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ]
   }
  },
  "walls": {
   "guideKey": "microcement",
   "defaultSteps": [
    "MATERIALS_NEEDED",
    "PREP_WALLS",
    "ARDEX_X5",
    "GRIP_PRIMER",
    "DECORKRETE_APPLY",
    "DECORKRETE_SAND",
    "DUST_REMOVAL",
    "D20_PRIMER",
    "AQUAFLOOR_SEAL"
   ],
   "substrateOverrides": {
    "plywood": [
     "MATERIALS_NEEDED",
     "PREP_WALLS",
     "ARDEX_X5",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "cement-board": [
     "MATERIALS_NEEDED",
     "PREP_WALLS",
     "ARDEX_X5_CEMENT_BOARD",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "tile": [
     "MATERIALS_NEEDED",
     "PREP_WALLS",
     "ARDEX_X5",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "concrete-dry": [
     "PREP_WALLS",
     "WATSTOP_FLOORS_1KG",
     "JOINTS",
     "DECORKRETE_APPLY",
     "TROWELING",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "concrete-damp-5": [
     "PREP_WALLS",
     "WATSTOP_FLOORS_2KG",
     "JOINTS",
     "DECORKRETE_APPLY",
     "TROWELING",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ]
   }
  },
  "countertops": {
   "guideKey": "microcement",
   "defaultSteps": [
    "MATERIALS_NEEDED",
    "PREP_COUNTERTOPS",
    "ARDEX_X5",
    "GRIP_PRIMER",
    "DECORKRETE_APPLY",
    "DECORKRETE_SAND",
    "DUST_REMOVAL",
    "D20_PRIMER",
    "AQUAFLOOR_SEAL"
   ],
   "substrateOverrides": {
    "concrete-dry": [
     "MATERIALS_NEEDED",
     "PREP_COUNTERTOPS",
     "WATSTOP_FLOORS_1KG",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "natural-stone": [
     "MATERIALS_NEEDED",
     "PREP_COUNTERTOPS",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ]
   }
  },
  "furniture": {
   "guideKey": "microcement",
   "defaultSteps": [
    "MATERIALS_NEEDED",
    "PREP_FURNITURE",
    "GRIP_PRIMER",
    "DECORKRETE_APPLY",
    "FURNITURE",
    "DECORKRETE_SAND",
    "DUST_REMOVAL",
    "D20_PRIMER",
    "AQUAFLOOR_SEAL"
   ],
   "substrateOverrides": {
    "wood": [
     "MATERIALS_NEEDED",
     "PREP_FURNITURE",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "FURNITURE",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "metal": [
     "MATERIALS_NEEDED",
     "PREP_FURNITURE",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "FURNITURE",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "laminate": [
     "MATERIALS_NEEDED",
     "PREP_FURNITURE",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "FURNITURE",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ]
   }
  },
  "fireplaces": {
   "guideKey": "microcement",
   "defaultSteps": [
    "MATERIALS_NEEDED",
    "PREP_FIREPLACE",
    "ARDEX_X5",
    "GRIP_PRIMER",
    "DECORKRETE_APPLY",
    "DECORKRETE_SAND",
    "DUST_REMOVAL",
    "D20_PRIMER",
    "AQUAFLOOR_SEAL"
   ],
   "substrateOverrides": {
    "plywood": [
     "MATERIALS_NEEDED",
     "PREP_FIREPLACE",
     "ARDEX_X5",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "tile": [
     "MATERIALS_NEEDED",
     "PREP_FIREPLACE",
     "ARDEX_X5",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "concrete-damp-5": [
     "MATERIALS_NEEDED",
     "PREP_FIREPLACE",
     "WATSTOP2KG_APPLY",
     "JOINTS",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ],
    "cement-board": [
     "MATERIALS_NEEDED",
     "PREP_FIREPLACE",
     "ARDEX_X5",
     "GRIP_PRIMER",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ]
   }
  },
  "patios": {
   "guideKey": "microcement",
   "defaultSteps": [
    "MATERIALS_NEEDED",
    "PREP_OUTDOOR",
    "WATSTOP_FLOORS_2KG",
    "EXPANSION_JOINTS",
    "DECORKRETE_APPLY",
    "DECORKRETE_SAND",
    "DUST_REMOVAL",
    "D20_PRIMER",
    "AQUAFLOOR_SEAL"
   ],
   "substrateOverrides": {
    "tile": [
     "MATERIALS_NEEDED",
     "PREP_OUTDOOR",
     "ARDEX_X5",
     "WATSTOP_FLOORS_2KG",
     "DECORKRETE_APPLY",
     "DECORKRETE_SAND",
     "DUST_REMOVAL",
     "D20_PRIMER",
     "AQUAFLOOR_SEAL"
    ]
   }
  },
  "pools": {
   "guideKey": "microcement",
   "defaultSteps": [
    "MATERIALS_NEEDED",
    "PREP_POOLS",
    "WATSTOP2KG",
    "JOINTS",
    "DECORKRETE_APPLY",
    "DECORKRETE_SAND",
    "DUST_REMOVAL",
    "POOL_PROTECTOR"
   ],
   "substrateOverrides": {}
  },
  "cork-walls-interior": {
   "guideKey": "cork-walls",
   "defaultSteps": [
    "CORK_MATERIALS",
    "CORK_PREP_WALLS",
    "CORK_PRIME",
    "CORK_MIX",
    "CORK_APPLY",
    "CORK_DRY",
    "CORK_SEAL_OPTIONS"
   ],
   "substrateOverrides": {}
  },
  "cork-walls-exterior": {
   "guideKey": "cork-walls",
   "defaultSteps": [
    "CORK_MATERIALS",
    "CORK_PREP_WALLS",
    "CORK_PRIME",
    "CORK_MIX",
    "CORK_APPLY",
    "CORK_DRY",
    "CORK_SEAL_OPTIONS"
   ],
   "substrateOverrides": {}
  }
 },
 "stepLibrary": {
  "MATERIALS_NEEDED": {
   "title": "Materials & Tools",
   "subtitle": "Gather everything before you begin"
  },
  "PREP_GENERAL": {
   "title": "Surface Preparation",
   "subtitle": "Clean, repair, and prepare substrate"
  },
  "PREP_WET_AREAS": {
   "title": "Surface Preparation- Showers & Wet Areas",
   "subtitle": "Clean, repair, and prepare substrate"
  },
  "PREP_FLOORS": {
   "title": "Surface Preparation - Floors",
   "subtitle": "Clean, repair, and prepare floor substrate"
  },
  "PREP_WALLS": {
   "title": "Surface Preparation - Walls",
   "subtitle": "Clean, repair, and prepare wall surfaces"
  },
  "PREP_COUNTERTOPS": {
   "title": "Surface Preparation - Countertops",
   "subtitle": "Prepare laminate, tile, or solid surface countertops"
  },
  "PREP_FIREPLACE": {
   "title": "Surface Preparation - Fireplaces & Range Hoods",
   "subtitle": "Prepare wood, brick, or metal surfaces"
  },
  "PREP_OUTDOOR": {
   "title": "Surface Preparation - Outdoor",
   "subtitle": "Prepare patios, terraces, and balconies"
  },
  "PREP_FURNITURE": {
   "title": "Surface Preparation · Furniture",
   "subtitle": "Prepare tables, cabinets, and custom pieces"
  },
  "PREP_POOLS": {
   "title": "Surface Preparation - Pools",
   "subtitle": "Prepare pool shell and water features"
  },
  "GRIP_PRIMER": {
   "title": "Grip Primer Application",
   "subtitle": "Adhesion promoter for non-concrete surfaces"
  },
  "WATSTOP1KG_APPLY": {
   "title": "WATstop Moisture Barrier",
   "subtitle": "Epoxy-cement moisture barrier"
  },
  "WATSTOP2KG_APPLY": {
   "title": "WATstop Waterproofing",
   "subtitle": "Epoxy-cement moisture barrier"
  },
  "WATSTOP_FLOORS_1KG": {
   "title": "WATstop Vapor Barrier · Floors",
   "subtitle": "Moisture protection for dry substrates"
  },
  "WATSTOP_FLOORS_2KG": {
   "title": "WATstop Waterproofing · Floors",
   "subtitle": "Two-coat moisture barrier for damp substrates"
  },
  "EXPANSION_JOINTS": {
   "title": "Expansion Joint Treatment",
   "subtitle": "Maintain flexibility with Diaseal Strong"
  },
  "ARDEX_X5": {
   "title": "Ardex X5 Joint Filling",
   "subtitle": "Fill joints, grout lines, and gaps"
  },
  "ARDEX_X5_CEMENT_BOARD": {
   "title": "Ardex X5 - Cement Board & Drywall Seams",
   "subtitle": "Fill and level all seams, joints, and imperfections"
  },
  "JOINTS": {
   "title": "Safety Joint Application",
   "subtitle": "Reinforcement tape for corners, junctions, and transitions"
  },
  "DECORKRETE_APPLY": {
   "title": "Decorkrete Application",
   "subtitle": "Apply decorative microcement coating"
  },
  "TROWELING": {
   "title": "Troweling Techniques",
   "subtitle": "Laying on, crossing and closing each coat"
  },
  "DECORKRETE_SAND": {
   "title": "Sanding Decorkrete",
   "subtitle": "Prepare surface for sealer application"
  },
  "DUST_REMOVAL": {
   "title": "Dust Removal",
   "subtitle": "Prepare surface for sealing"
  },
  "D20_PRIMER": {
   "title": "D20 Primer Application",
   "subtitle": "Consolidating primer before final sealer"
  },
  "AQUAFLOOR_SEAL": {
   "title": "Aquafloor Eco Sealer",
   "subtitle": "Protective polyurethane coating"
  },
  "POOL_PROTECTOR": {
   "title": "Pool Protector Application",
   "subtitle": "UV-resistant sealer for submerged surfaces"
  },
  "EFFECTS": {
   "title": "Decorative Effects",
   "subtitle": "Create texture and visual interest"
  },
  "FURNITURE": {
   "title": "Furniture Techniques",
   "subtitle": "Application tips for tables, chairs, and decor"
  },
  "CORK_MATERIALS": {
   "title": "Materials & Tools",
   "subtitle": "Gather everything before you begin"
  },
  "CORK_PREP_WALLS": {
   "title": "Prepare the Wall",
   "subtitle": "Sound, dry and clean, with every joint sealed"
  },
  "CORK_PRIME": {
   "title": "Prime for Your Substrate",
   "subtitle": "The wall decides the primer"
  },
  "CORK_MIX": {
   "title": "Mix the Coating",
   "subtitle": "Whole toner pack, high-speed mix"
  },
  "CORK_APPLY": {
   "title": "Apply Two Coats",
   "subtitle": "Thin, even coats, one wall at a time"
  },
  "CORK_DRY": {
   "title": "Drying & Protection",
   "subtitle": "Calm conditions while it cures"
  },
  "CORK_SEAL_OPTIONS": {
   "title": "Optional Protection",
   "subtitle": "For high-traffic and wet-region walls"
  }
 },
 "guidePagePath": "/pages/installation-guides",
 "terms": {
  "freeShip": 1000.0,
  "shipsWithin": "5 business days",
  "specialOrder": "4–6 weeks"
 }
};
